import { render, staticRenderFns } from "./CreateCustomModel.vue?vue&type=template&id=badb581c&"
import script from "./CreateCustomModel.vue?vue&type=script&lang=js&"
export * from "./CreateCustomModel.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomModel.vue?vue&type=style&index=0&id=badb581c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports